import React, { useCallback } from 'react';
import { StyleSheet, View } from 'react-native';
import { CardView, rem } from 'design-system';
import Modal from 'utils/packages/Modal';
import { IconBank } from 'design-system/icons';
import { SettingsItem } from 'design-system/SettingsItem';
import createStyleSheets from 'utils/createStyleSheets';
import useStyles from 'hooks/useStyles';
import IconTransfer from 'design-system/icons/IconTransfer';
import { isWeb } from '../../../constants';
const AddSpaceAccountModalContent = ({ onAddAccount, onMoveAccounts, }) => {
    const webStyles = useStyles(webStyleSet);
    const onPressAddAccount = useCallback(() => {
        Modal.hide(onAddAccount);
    }, [onAddAccount]);
    const onPressMoveAccounts = useCallback(() => {
        Modal.hide(onMoveAccounts);
    }, [onMoveAccounts]);
    if (isWeb) {
        return (<View style={styles.modalContent}>
        <CardView noMargin webPadding style={webStyles.modalContent}>
          <SettingsItem style={webStyles.settingsItem} icon={<IconBank gradientKey="lightPurple"/>} title="Add new account" onPress={onPressAddAccount}/>
          <SettingsItem style={webStyles.settingsItem} icon={<IconTransfer gradientKey="skyBlue"/>} title="Move from other spaces" onPress={onPressMoveAccounts}/>
        </CardView>
      </View>);
    }
    return (<View style={styles.modalContent}>
      <SettingsItem icon={<IconBank gradientKey="lightPurple"/>} title="Add new account" onPress={onPressAddAccount}/>
      <SettingsItem icon={<IconTransfer gradientKey="skyBlue"/>} title="Move from other spaces" onPress={onPressMoveAccounts}/>
    </View>);
};
export default AddSpaceAccountModalContent;
const styles = StyleSheet.create({
    modalContent: {
        paddingTop: rem(12),
    },
});
const webStyleSet = createStyleSheets((colors) => ({
    modalContent: {
        marginHorizontal: rem(16),
        backgroundColor: colors.background.light,
    },
    settingsItem: {
        margin: rem(16),
    },
}));
